export const programsMessages = {
  reportSuccess: 'The report was generated successfully.',
  reportError: 'Unknown error occurred.',
  exportSuccess: 'The export was generated successfully.',
  exportError: 'Unknown error occurred.',
};
